import React from "react"
import { withStyles, WithStyles, createStyles } from "@material-ui/core"
import LogoAndText from "./LogoAndText"
import Description from "./Description"
import StoreButtons from "../../CallToAction/Top/StoreButtons"

const styles = () => {
  return createStyles({
    root: {
      flexShrink: 0,
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const Body = ({ classes }: Props) => {
  return (
    <div className={classes.root}>
      <LogoAndText />
      <Description />
      <StoreButtons />
    </div>
  )
}

export default withStyles(styles)(Body)
